module.exports = __webpack_public_path__ + "static/media/olivia_tidalpaints.c28cc3d9.jpg";